module.exports = __webpack_public_path__ + "static/img/naniungo-slide-9-slogan.4d872507.jpg";